export interface TimePeriodOption {
  value: string;
  label: string;
}

export const TIME_PERIOD_OPTIONS: TimePeriodOption[] = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'daily', label: 'Daily' },
];

export const DEFAULT_TIME_PERIOD = 'monthly';
